import * as React from "react";
import classNames from "classnames";
import { DropdownType } from "../enums";

interface IDropdownList {
    selectedValue: string | number;
    attributes: number[] | IMultiRowList[] | ISingleRowList[];
    type: string;
    clicked: (attribute: IMultiRowList | ISingleRowList) => void;
}

export interface IMultiRowList {
    labelRows: string[] | number[];
    value: string | number;
}

export interface ISingleRowList {
    label: string | number;
    value: string | number;
}

export const DropdownList = (props: IDropdownList): JSX.Element => {
    const SingleTypeList = () => (
        <>
            {(props.attributes as ISingleRowList[]).map((attribute, i) => (
                <span
                    className={classNames("listRow", { active: attribute.value === props.selectedValue })}
                    onClick={() => props.clicked(attribute)}
                    key={attribute.value.toString() + Math.random() * i}
                >
                    {attribute.value}
                </span>
            ))}
        </>
    );

    const MultiTypeList = () => (
        <>
            {(props.attributes as IMultiRowList[]).map((attribute: IMultiRowList, i: number) =>
                attribute.labelRows ? (
                    <span
                        key={attribute.value.toString() + i}
                        onClick={() => props.clicked(attribute)}
                        className={classNames("listRow", { active: attribute.value === props.selectedValue })}
                    >
                        {attribute.labelRows.map((row: string | number, i: number) => (
                            <span key={row.toString() + i}>{row}</span>
                        ))}
                    </span>
                ) : null
            )}
        </>
    );

    return (
        <div className="dropdown-list">
            {props.attributes && props.attributes.length ? (
                props.type === DropdownType.SingleLine ? (
                    <SingleTypeList />
                ) : (
                    <MultiTypeList />
                )
            ) : null}
        </div>
    );
};
